/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ImportTechStackDto } from '../models/import-tech-stack-dto';
import { ImportTechStackResultDto } from '../models/import-tech-stack-result-dto';
import { ImportTechStackStatusDto } from '../models/import-tech-stack-status-dto';
import { PagedTechStacksDto } from '../models/paged-tech-stacks-dto';

@Injectable({
  providedIn: 'root',
})
export class TechStackService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTechStacks
   */
  static readonly GetTechStacksPath = '/techstacks';

  /**
   * Get Tech Stacks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTechStacks()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechStacks$Response(params: {
    pageIndex: number;
    pageSize: number;

    /**
     * Use field names from the ProductDTO
     */
    orderBy: string;
    companyId?: string;
    userId?: string;
    type?: string;
  }): Observable<StrictHttpResponse<PagedTechStacksDto>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.GetTechStacksPath, 'get');
    if (params) {
      rb.query('pageIndex', params.pageIndex, {});
      rb.query('pageSize', params.pageSize, {});
      rb.query('orderBy', params.orderBy, {});
      rb.query('companyId', params.companyId, {});
      rb.query('userId', params.userId, {});
      rb.query('type', params.type, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PagedTechStacksDto>;
      })
    );
  }

  /**
   * Get Tech Stacks.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTechStacks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTechStacks(params: {
    pageIndex: number;
    pageSize: number;

    /**
     * Use field names from the ProductDTO
     */
    orderBy: string;
    companyId?: string;
    userId?: string;
    type?: string;
  }): Observable<PagedTechStacksDto> {

    return this.getTechStacks$Response(params).pipe(
      map((r: StrictHttpResponse<PagedTechStacksDto>) => r.body as PagedTechStacksDto)
    );
  }

  /**
   * Path part for operation exportTechStacks
   */
  static readonly ExportTechStacksPath = '/techstacks/export';

  /**
   * Export Tech Stacks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportTechStacks()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTechStacks$Response(params?: {
    companyDomain?: string;
    companyId?: string;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.ExportTechStacksPath, 'get');
    if (params) {
      rb.query('companyDomain', params.companyDomain, {});
      rb.query('companyId', params.companyId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/csv'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Export Tech Stacks.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exportTechStacks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTechStacks(params?: {
    companyDomain?: string;
    companyId?: string;
  }): Observable<string> {

    return this.exportTechStacks$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation importTechStacks
   */
  static readonly ImportTechStacksPath = '/techstacks/import';

  /**
   * Imports stacks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importTechStacks()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importTechStacks$Response(params: {
    body: Array<ImportTechStackDto>
  }): Observable<StrictHttpResponse<Array<ImportTechStackResultDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.ImportTechStacksPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ImportTechStackResultDto>>;
      })
    );
  }

  /**
   * Imports stacks.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `importTechStacks$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importTechStacks(params: {
    body: Array<ImportTechStackDto>
  }): Observable<Array<ImportTechStackResultDto>> {

    return this.importTechStacks$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ImportTechStackResultDto>>) => r.body as Array<ImportTechStackResultDto>)
    );
  }

  /**
   * Path part for operation importTechStacksAsync
   */
  static readonly ImportTechStacksAsyncPath = '/techstacks/import/async';

  /**
   * Imports stacks asynchronously.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importTechStacksAsync()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importTechStacksAsync$Response(params: {
    body: Array<ImportTechStackDto>
  }): Observable<StrictHttpResponse<{
'importId'?: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.ImportTechStacksAsyncPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'importId'?: string;
        }>;
      })
    );
  }

  /**
   * Imports stacks asynchronously.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `importTechStacksAsync$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  importTechStacksAsync(params: {
    body: Array<ImportTechStackDto>
  }): Observable<{
'importId'?: string;
}> {

    return this.importTechStacksAsync$Response(params).pipe(
      map((r: StrictHttpResponse<{
'importId'?: string;
}>) => r.body as {
'importId'?: string;
})
    );
  }

  /**
   * Path part for operation getImportTechStacksAsync
   */
  static readonly GetImportTechStacksAsyncPath = '/techstacks/import/async/{importId}/items';

  /**
   * Get async import details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getImportTechStacksAsync()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImportTechStacksAsync$Response(params: {
    importId: string;
  }): Observable<StrictHttpResponse<Array<ImportTechStackResultDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.GetImportTechStacksAsyncPath, 'get');
    if (params) {
      rb.path('importId', params.importId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ImportTechStackResultDto>>;
      })
    );
  }

  /**
   * Get async import details.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getImportTechStacksAsync$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImportTechStacksAsync(params: {
    importId: string;
  }): Observable<Array<ImportTechStackResultDto>> {

    return this.getImportTechStacksAsync$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ImportTechStackResultDto>>) => r.body as Array<ImportTechStackResultDto>)
    );
  }

  /**
   * Path part for operation getImportTechStacksAsyncStatus
   */
  static readonly GetImportTechStacksAsyncStatusPath = '/techstacks/import/async/{importId}/status';

  /**
   * Get status of async import. This method is intended for polling.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getImportTechStacksAsyncStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImportTechStacksAsyncStatus$Response(params: {
    importId: string;
  }): Observable<StrictHttpResponse<Array<ImportTechStackStatusDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TechStackService.GetImportTechStacksAsyncStatusPath, 'get');
    if (params) {
      rb.path('importId', params.importId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ImportTechStackStatusDto>>;
      })
    );
  }

  /**
   * Get status of async import. This method is intended for polling.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getImportTechStacksAsyncStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getImportTechStacksAsyncStatus(params: {
    importId: string;
  }): Observable<Array<ImportTechStackStatusDto>> {

    return this.getImportTechStacksAsyncStatus$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ImportTechStackStatusDto>>) => r.body as Array<ImportTechStackStatusDto>)
    );
  }

}
